import { staticSelector } from 'ducks/static'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { Footer } from 'views/components/Footer'
import { Header } from 'views/components/Header'
import { Loader } from 'views/components/Loader'
import { States } from 'views/components/States'
import { Container } from './styled'

export const ParticipatingStates: FC = () => {
  const state = useSelector(staticSelector)

  return (
    <>
      {state.content?.nationalState ? (
        <Container>
          <Header />
          <States />
          <Footer />
        </Container>
      ) : (
        <Loader />
      )}
    </>
  )
}
